import { App } from '@capacitor/app';
import React from 'react';
import { useTranslation } from 'react-i18next';

import PlayerTag from './PlayerTag.jsx';

import { AppContext } from '../AppContext';

const MainMenu = () => {
	const { t } = useTranslation();
	const app = React.useContext(AppContext);
	const tapCount = React.useRef(0);

	const version = app.version;
	const config = app.config;

	const showMoreGames = config.showMoreGames === false ? false : app.marketPlace.hasGames();
	const showAbout = config.showAbout;

	const tapTitle = React.useCallback(() => {
		app.userdata.titleTapped = (app.userdata.titleTapped || 0) + 1;
		app.achievements.checkForAchievementAndReward(app.userdata);
		app.save();
	}, [app]);

	const tapVersion = React.useCallback(() => {
		tapCount.current++;

		if (tapCount.current > 10) {
			app.navigate('Test');
		}
	}, [app]);

	const removeAds = React.useMemo(() => {
		if (app.userdata.removeAds || !app.iap?.isAvailable) {
			return null;
		}

		return (
			<a href="#Store"><i className="ui-icon ui-remove-ads" /></a>
		);
	}, [app.iap?.isAvailable, app.userdata?.removeAds]);

	React.useEffect(() => {
		const listener = () => {
			App.exitApp();
		};

		let removeHandler;

		App.addListener('backButton', listener).then((handle) => {
			removeHandler = handle.remove;
		});

		return () => {
			if (typeof removeHandler === 'function') {
				removeHandler();
			} else {
				App.removeAllListeners();
			}
		};
	}, []);

	return (
		<div id="MainMenu1" className="page1 activePage paddingTop50">
			<div className="wrapper">
				<div className="pageTitle" style={{
					padding: '25px 0 5px 0',
				}}>
					<img src="assets/Title.png" onClick={tapTitle} />
				</div>
				<ul className="buttonList" >
					<li>
						<a className="button buttonEasy" href="#ComputerMenu">
							{t('Play')}
						</a>
					</li>
					<li>
						<a className="button buttonMedium" href="#Online">
							{t('Online')}
						</a>
					</li>
					<li>
						<a className="button buttonHard" href="#Achievements">
							{t('Achievements')}
						</a>
					</li>
					<li>
						<PlayerTag />
					</li>
					<li>
						<div className="minibuttons" >
							<a href="#HowToPlay"><i className="ui-icon ui-question-mark" /></a>

							<a href="#Achievements"><i className="ui-icon ui-achievement" /></a>
							<a href="#Statistics"><i className="ui-icon ui-stats" /></a>
							{showAbout && (<a href="#About"><i className="ui-icon ui-mail" /></a>)}
							{/* <a data-show="showRateGame" > <img src="assets/Buttons/white/heart.png" /> </a> */}
							{/* <a href="#Settings"><img src="assets/Buttons/white/settings.png" /></a> */}
							{removeAds}
						</div>
					</li>
					{showMoreGames && (
						<li style={{
							textAlign: 'center',
						}}>
							<div >
								<a className="buttonMoreGames" href="#MoreGames">
								</a>
								<div>{t('More Games')}</div>
							</div>
						</li>
					)}
					{!showMoreGames && (
						<li style={{
							textAlign: 'center',
							margin: '8px 8px',
						}}>
							JD Games
						</li>
					)}

					<li style={{
						textAlign: 'center',
						margin: '10px 10px',
						userSelect: 'none',
					}}>
						<div onClick={tapVersion}  >
							{version}
						</div>
					</li>
				</ul>
			</div>

		</div>
	);
};

export default MainMenu;
